import * as React from "react";
import parse from "html-react-parser";
import * as styles from "./styles.scss";

interface IProps {
  info: string;
}

export const PageInfo = ({ info }: IProps) => {
  return (
    <div className="mini-window__course">
      <div
        className={`mini-window__course__description ${styles.miniWindowCourseDescription}`}
      >
        {parse(info, {
          replace: function(domNode) {
            if (domNode.type === "script") {
              let script = document.createElement("script");
              script.src = domNode.attribs.src;
              script.type = domNode.attribs.type;
              script.async = true;
              script.defer = true;
              document.head.appendChild(script);
            }
          },
        })}
      </div>
      <div className="br" />
    </div>
  );
};
